var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10.8,
    viewBox: "0 0 12 10.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24196",
    "data-name": "Path 24196",
    d: "M3.091,7.8h9.818A1.149,1.149,0,0,1,14,9v1.2a1.149,1.149,0,0,1-1.091,1.2H3.091A1.149,1.149,0,0,1,2,10.2V9A1.149,1.149,0,0,1,3.091,7.8ZM3.2,9v1.2h9.6V9ZM3.091,3h9.818A1.149,1.149,0,0,1,14,4.2V5.4a1.149,1.149,0,0,1-1.091,1.2H3.091A1.149,1.149,0,0,1,2,5.4V4.2A1.149,1.149,0,0,1,3.091,3ZM3.2,4.2V5.4h9.6V4.2ZM2,12.6H9.2v1.2H2Z",
    transform: "translate(-2 -3)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/booking-icon.b35f02e1401f76dd794afc9e49f0489e.svg";
export { ForwardRef as ReactComponent };